import $ from 'jquery'

export function providerSlide() {
  var moveStart = 0
  var providerW = $('.provider-content').width()
  var providerContainerW = $('.provider-container').width()

  if (providerW > providerContainerW) {
    $('.provider-right-icon').show()
    var moveDistance = providerW - providerContainerW
    var moveUnit = 150
    var moveDefault = 0
    var moveEnd = moveDefault - moveDistance

    moveStart = 0

    $('.provider-right-icon').unbind('click').click(function() {
      $('.provider-left-icon').show()
      if (moveStart <= moveDefault && moveStart > moveEnd) {
        moveStart = moveStart - moveUnit
        if (moveStart <= moveEnd) {
          moveStart = moveEnd
          $('.provider-right-icon').hide()
        }
        $('.provider-content').stop().animate({ 'left': moveStart })
      }
    })

    $('.provider-left-icon').unbind('click').click(function() {
      $('.provider-right-icon').show()
      if (moveStart >= moveEnd && moveStart < moveDefault) {
        moveStart = moveStart + moveUnit
        if (moveStart >= moveDefault) {
          moveStart = moveDefault
          $('.provider-left-icon').hide()
        }
        $('.provider-content').stop().animate({ 'left': moveStart })
      }
    })
  }
}

export function startMarquees() {
  var speed = 50 // speed -- px/second

  var $marquee = document.querySelector('.marquee')
  var $marqueeContent = $marquee.querySelector('.content')
  // copy 3 times to continue
  $marqueeContent.innerHTML = $marqueeContent.innerHTML + $marqueeContent.innerHTML + $marqueeContent.innerHTML
  var contentWidth = $marqueeContent.getBoundingClientRect().width
  if (contentWidth <= 0) { // no content
    return
  }

  // because copy 3 times -> width/3
  contentWidth = contentWidth / 3

  var onceTime = contentWidth / speed * 1000 // ms

  $marqueeContent.style.animationDuration = onceTime + 'ms'
}

export function handleTabProviderFix() {
  var ua = navigator.userAgent
  var is_iOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios
  if (is_iOS === true && ua.toLowerCase().indexOf('safari') > 0) {
    setInterval(function() {
      var w_st = $(window).scrollTop()
      var nScrollTop = $('#tab-provider_flex').position().top - w_st
      // console.log('tab-provider_flex scrollTop : ' + nScrollTop);

      if (nScrollTop <= 51) {
        $('.tab-provider').addClass('fixed')
        $('.tab-provider_flex').addClass('tabfixed')
      } else {
        $('.tab-provider').removeClass('fixed')
        $('.tab-provider_flex').removeClass('tabfixed')
      }
    }, 100)
  } else {
    $(window).scroll(function() {
      var w_st = $(window).scrollTop()
      var nScrollTop = $('#tab-provider_flex').position().top - w_st
      // console.log('tab-provider_flex scrollTop : ' + nScrollTop);

      if (nScrollTop <= 51) {
        $('.tab-provider').addClass('fixed')
        $('.tab-provider_flex').addClass('tabfixed')
      } else {
        $('.tab-provider').removeClass('fixed')
        $('.tab-provider_flex').removeClass('tabfixed')
      }
    })
  }
}
